// src/components/AppLinks.js — "Uygulamayı yükle", "Ana sayfam yap" ve Google Play düğmeleri
import React, { useState } from 'react';
import { Modal } from './ui';
import { useInstall, promptInstall, homepageSteps } from '../pwa/install';

export const ZARSALLA_URL = 'https://zarsalla.com';
export const ZARSALLA_PLAY_URL = 'https://play.google.com/store/apps/details?id=zar.salla';
export const OKEY_PLAY_URL = 'https://play.google.com/store/apps/details?id=arkadas.okey';

function InstallHelp({ ios }) {
  if (ios) {
    return (
      <ol className="steps-list">
        <li>Safari’de alttaki <strong>Paylaş</strong> düğmesine (kare ve yukarı ok) dokunun.</li>
        <li>Listeden <strong>Ana Ekrana Ekle</strong>’yi seçin.</li>
        <li><strong>Ekle</strong>’ye dokunun. Oyuntu ana ekranınızda uygulama gibi açılır.</li>
      </ol>
    );
  }
  return (
    <ol className="steps-list">
      <li>Chrome ya da Edge’de adres çubuğundaki <strong>yükle</strong> simgesine (⊕) ya da menüdeki <strong>Uygulamayı yükle / Ana ekrana ekle</strong> seçeneğine dokunun.</li>
      <li><strong>Yükle</strong>’yi onaylayın.</li>
      <li>Oyuntu masaüstünüzde ya da ana ekranınızda kendi penceresinde açılır.</li>
    </ol>
  );
}

/** PWA yükleme düğmesi: tarayıcı destekliyorsa pencereyi açar, değilse adımları gösterir. */
export function InstallButton({ className = 'oy-btn oy-btn-primary oy-btn-sm', label = 'Uygulamayı yükle' }) {
  const { canPrompt, ios, installed } = useInstall();
  const [help, setHelp] = useState(false);
  if (installed) return null;
  const onClick = async () => {
    if (canPrompt) {
      const r = await promptInstall();
      if (r !== 'unavailable') return;
    }
    setHelp(true);
  };
  return (
    <>
      <button type="button" className={className} onClick={onClick}>
        <span aria-hidden="true">⤓</span> {label}
      </button>
      <Modal open={help} onClose={() => setHelp(false)} title="Oyuntu’yu ana ekrana ekle">
        <p>Oyuntu bir web uygulamasıdır (PWA): indirmeden, mağazaya gerek kalmadan ana ekrana eklenir ve tam ekran açılır.</p>
        <InstallHelp ios={ios} />
      </Modal>
    </>
  );
}

/** Tarayıcı açılış sayfası yapma: tarayıcılar buna izin vermediği için adımları gösterir. */
export function HomepageButton({ className = 'oy-btn oy-btn-light oy-btn-sm', label = 'Ana sayfam yap' }) {
  const [open, setOpen] = useState(false);
  const info = open ? homepageSteps() : null;
  const copy = () => {
    try {
      navigator.clipboard.writeText('https://oyuntu.com');
    } catch {
      /* pano kapalı */
    }
  };
  return (
    <>
      <button type="button" className={className} onClick={() => setOpen(true)}>
        <span aria-hidden="true">⌂</span> {label}
      </button>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title="Oyuntu’yu açılış sayfası yap"
        footer={
          <button type="button" className="oy-btn oy-btn-light oy-btn-sm" onClick={copy}>
            Adresi kopyala
          </button>
        }
      >
        {info && (
          <>
            <p>Tarayıcınız ({info.browser}) açıldığında Oyuntu gelsin:</p>
            <ol className="steps-list">
              {info.steps.map((s) => (
                <li key={s}>{s}</li>
              ))}
            </ol>
          </>
        )}
      </Modal>
    </>
  );
}

/** Google Play rozeti biçiminde düğme */
export function PlayStoreButton({ href = ZARSALLA_PLAY_URL, app = 'Zar Salla' }) {
  return (
    <a className="play-badge" href={href} target="_blank" rel="noopener noreferrer" aria-label={`${app} uygulamasını Google Play'den indir`}>
      <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
        <path fill="#34a853" d="M3.6 1.8 13.4 12l-9.8 10.2c-.4-.2-.6-.7-.6-1.2V3c0-.5.2-1 .6-1.2Z" />
        <path fill="#fbbc04" d="m16.8 8.6-3.4 3.4 3.4 3.4 3.9-2.2c.8-.5.8-1.8 0-2.3l-3.9-2.3Z" />
        <path fill="#4285f4" d="M3.6 1.8c.3-.2.8-.2 1.2 0l12 6.8-3.4 3.4L3.6 1.8Z" />
        <path fill="#ea4335" d="M13.4 12l3.4 3.4-12 6.8c-.4.2-.9.2-1.2 0L13.4 12Z" />
      </svg>
      <span>
        <small>{app} · Android</small>
        <strong>Google Play’den indir</strong>
      </span>
    </a>
  );
}
